import { Utils } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { BonusController } from "./BonusController";
import { DataManager } from "../../Managers/DataManager";
import { GameManager } from "../../Managers/GameManager";
import { MessageManager } from "../../Managers/MessageManager";

export class BonusModel {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    protected controller: BonusController;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor(controller: BonusController) {
        this.controller = controller;
    }

    //******************************************************************************************************************
    //  REQUESTS
    //******************************************************************************************************************

    public start(): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;
        DataManager.controlAutoplay();
        GameManager.gameClient.bonusRespinsStart().then((response: any): any => {
            MessageManager.postpone(this.startReceived.bind(this), response);
        });
    }

    public spin(): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;
        DataManager.controlAutoplay();
        GameManager.gameClient
            .bonusRespinsSpin(Communication.Game.GameModules.BonusRespins)
            .then((response: any): any => {
                MessageManager.postpone(this.spinReceived.bind(this), response);
            });
    }

    public end(): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;
        DataManager.controlAutoplay();
        GameManager.gameClient.endBonusRespins().then((response: any): any => {
            MessageManager.postpone(this.endReceived.bind(this), response);
        });
    }

    public respin(): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;
        DataManager.controlAutoplay();
        GameManager.gameClient
            .respin(Communication.Game.GameModules.BonusRespins, GameManager.bonusRespinsResponse.respin)
            .then((response: any): any => {
                MessageManager.postpone(this.respinReceived.bind(this), response);
            });
    }

    //******************************************************************************************************************
    //  RESPONSES
    //******************************************************************************************************************

    protected startReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            Platforms.Platforms.featureStarted({ type: Communication.Game.GameModules.BonusRespins });
            this.controller.startReceived();
        }

        GameManager.requestSend = false;
    }

    protected spinReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            this.controller.spinReceived();
        }

        GameManager.requestSend = false;
    }

    protected endReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            Platforms.Platforms.featureFinished({ type: Communication.Game.GameModules.BonusRespins });
            this.controller.endReceived();
        }

        GameManager.requestSend = false;
    }

    private respinReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            this.controller.respinReceived();
        }

        GameManager.requestSend = false;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Bonus/BonusModel.ts
 **/